// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "h3[id='not-found'], h2[id='return-home'] {\r\n  text-align: center;\r\n  font-weight: 700;\r\n  line-height: 50px;\r\n}", "",{"version":3,"sources":["NoMatchPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","file":"NoMatchPage.css","sourcesContent":["h3[id='not-found'], h2[id='return-home'] {\r\n  text-align: center;\r\n  font-weight: 700;\r\n  line-height: 50px;\r\n}"]}]);
// Exports
module.exports = exports;
